import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmptyRecordComponent } from './empty-record.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  exports: [EmptyRecordComponent],
  declarations: [EmptyRecordComponent],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class EmptyRecordModule { }
